// ============================================================
// ItkSupportRoutes — replaces itk-support.module.ts routes
// Route entry: /itk-support/*
//
// Usage in root router:
//   <Route path="/itk-support/*" element={<ItkSupportRoutes />} />
//
// Migrated so far:
//   ✅  center-support             → ItkCenterSupport.tsx
//   ✅  itk-discontinued-status-change → ItkDiscontinuedStatusChange.tsx
//   ✅  smc-first-verification     → SmcFirstVerification.tsx
//   ✅  itk-lms-score              → ItkLmsScore.tsx
//
// TODO — migrate remaining sub-routes as needed:
//   inbox-message, feedback-queries, itk-grievance-bank-verification,
//   non-marked-attendance-tracker, itk-mobile-app-activation,
//   itk-state-approval, itk-discontinued-status-change,
//   itk-partially-pending-image, nameChangeAprrov,
//   itk-volun-verify, itk-voln-correcrection-details,
//   itk-discontinue-request, itk-new-vol-registration,
//   itk-lms-score, itk-new-vol-final-selection, smc-first-verification
// ============================================================
import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

const ItkCenterSupport = lazy(
  () => import('./center-support/ItkCenterSupport')
);
const ItkDiscontinuedStatusChange = lazy(
  () => import('./itk-discontinued-status-change/ItkDiscontinuedStatusChange')
);
const SmcFirstVerification = lazy(
  () => import('./smc-first-verification/SmcFirstVerification')
);
const ItkMobileAppActivation = lazy(
  () => import('./itk-mobile-app-activation/ItkMobileAppActivation')
);
const ItkLmsScore = lazy(() => import('./itk-lms-score/ItkLmsScore'));

const Loader = () => (
  <div className="d-flex justify-content-center py-5">
    <div className="spinner-border text-primary" role="status" />
  </div>
);

const ItkSupportRoutes: React.FC = () => (
  <Suspense fallback={<Loader />}>
    <Routes>
      <Route path="center-support" element={<ItkCenterSupport />} />
      <Route
        path="itk-discontinued-status-change"
        element={<ItkDiscontinuedStatusChange />}
      />
      <Route path="smc-first-verification" element={<SmcFirstVerification />} />
      <Route
        path="itk-mobile-app-activation"
        element={<ItkMobileAppActivation />}
      />
      <Route path="itk-lms-score" element={<ItkLmsScore />} />
      {/* Add remaining routes here as they get migrated */}
    </Routes>
  </Suspense>
);

export default ItkSupportRoutes;
